import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Element, scroller } from 'react-scroll';
import styled from 'styled-components';
import { notification } from '../store/actions';

const Error = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: white;
`;

const ErrorWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: #a83569;
  color: white;
  padding: 16px 40px 16px 16px;
  margin-bottom: 25px;

  .close-icon {
    position: absolute;
    right: 25px;
    top: 17px;
    z-index: 999;
    font-size: 16px;
    cursor: pointer;
  }
`;

function ShowErrors({ error, toast, onNotification, className, scroll }) {
  const [errorMessages, setErrorMessages] = useState([]);

  useEffect(() => {
    if (toast && errorMessages.length > 0) {
      onNotification(errorMessages[0], 'error');
    }
  }, [errorMessages]);

  useEffect(() => {
    if (scroll && !errorMessages.length == 0) {
      scroller.scrollTo(`error-${error}`, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -200
      });
    }
  }, [error]);

  useEffect(() => {
    setErrorMessages([]);
    if (error) {
      if (error.custom && error.messages) {
        setErrorMessages([...errorMessages, ...error.messages]);
      } else {
        if (typeof error === 'string') {
          setErrorMessages([...errorMessages, [error]]);
        } else {
          //checks network error or other.
          if (error?.graphQLErrors?.length === 0) {
            setErrorMessages([
              ...errorMessages,
              [
                `Something went wrong, please check your connection and try again.`
              ]
            ]);
          } else {
            // auth errors
            if (error.graphQLErrors[0].category === 'authentication') {
              const message = error.graphQLErrors[0].message;

              setErrorMessages([...errorMessages, message]);
            }
            // custom errors
            if (
              error.graphQLErrors[0].extensions &&
              error.graphQLErrors[0].extensions.category === 'validation'
            ) {
              const errorObj = error.graphQLErrors[0].extensions.validation;
              for (let key in errorObj) {
                setErrorMessages([...errorMessages, errorObj[key]]);
              }
            }
            // graphQL errors.
            if (
              error.graphQLErrors[0].extensions &&
              error.graphQLErrors[0].extensions.category === 'graphql'
            ) {
              error.graphQLErrors.map(error => {
                const errorToShow = error.message.includes(
                  '400 Bad Request – To zip'
                )
                  ? error.message.replace('400 Bad Request – To zip', 'Zip ')
                  : error.message;

                setErrorMessages([...errorMessages, errorToShow]);
              });
            }
          }
        }
      }
    }
  }, [error]);

  //returns nothing if there's no errors
  if (errorMessages.length == 0) return '';

  const getError = error => {
    switch (error) {
      case 'account_already_exists':
        return 'An account already exists for this email address';
      case 'thank_you_already_trade_log_in':
        return (
          <span>
            Thank you for being a member of our trade community. You are already
            signed up for a trade account and receiving trade benefits.{' '}
            <Link to="/login">Sign in to your account</Link>
          </span>
        );

      case 'account_already_exists_log_in':
        return (
          <span>
            An account already exists for this email address. Please{' '}
            <Link to="/login">Sign in</Link> to your existing account to sign up
            for trade
          </span>
        );
      default:
        return error;
    }
  };

  if (toast) {
    return null;
  }

  return (
    <Element
      name={`error-${getError(error)}`}
      className="element error-box-element"
    >
      <ErrorWrapper className={`error-wrapper ${className}`}>
        {errorMessages.map((error, i) => (
          <Error key={i}>{getError(error)}</Error>
        ))}
      </ErrorWrapper>
    </Element>
  );
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  onNotification: (message, type) => {
    dispatch(notification({ message, type }));
  }
});

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(ShowErrors);
